export default __webpack_public_path__ + "1affa2e99f0ae9a9966fb19ebc5b095b.png";